import { useTranslation } from "@refinedev/core";
import DateTimePicker from "components/datetimePicker";
import Input from "components/input";
import { Label } from "components/label";
import {
  IAdditionalSetupData,
  IAdditionalSetupForm,
  ISimpleEventDetail,
} from "interfaces";
import { get } from "lodash";
import moment from "moment";
import { Controller, useFormContext } from "react-hook-form";
import { formatNumber } from "utills/helpers";

export const LegalInfo = ({
  additionalSetupData,
}: {
  additionalSetupData: IAdditionalSetupData | null;
}) => {
  const { translate } = useTranslation();

  return (
    <div className="box-container p-4 sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6 text-sm">
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.company_name" name="Tên công ty" />
          <p>{additionalSetupData?.legal_info?.company_name}</p>
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.address" name="Địa chỉ" />
          <p>{additionalSetupData?.legal_info?.address}</p>
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.tax_code" name="Mã số thuế" />
          <p>{additionalSetupData?.legal_info?.tax_code}</p>
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.phone" name="Điện thoại" />
          <p>{additionalSetupData?.legal_info?.phone}</p>
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.representative" name="Đại diện" />
          <p>{additionalSetupData?.legal_info?.representative}</p>
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.position" name="Chức vụ" />
          <p>{additionalSetupData?.legal_info?.position}</p>
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.account_name" name="Tên tài khoản ngân hàng" />
          <p>{additionalSetupData?.legal_info?.account_name}</p>
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.account_number" name="Số tài khoản" />
          <p>{additionalSetupData?.legal_info?.account_number}</p>
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.bank" name="Ngân hàng" />
          <p>{additionalSetupData?.legal_info?.bank}</p>
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.contract_number" name="Số hợp đồng" />
          <p>{additionalSetupData?.legal_info?.contract_number}</p>
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.service_fee" name="Phí dịch vụ (%)" />
          <p>{formatNumber(additionalSetupData?.legal_info?.service_fee ?? 0)}</p>
        </div>
        <div className="col-span-full sm:col-span-3">
          <Label id="legal_info.vat" name="Thuế GTGT (%)" />
          <p>{additionalSetupData?.legal_info?.vat}</p>
        </div>
      </div>
    </div>
  );
};
